import { useCallback, useEffect, useState } from 'react';
import { INDUSTRY_NEWS_SEARCH_PARAM } from '../utils/industryNewsSearch';

function readSearchFromUrl(): string {
  if (typeof window === 'undefined') {
    return '';
  }

  return new URLSearchParams(window.location.search).get(INDUSTRY_NEWS_SEARCH_PARAM) ?? '';
}

function writeSearchToUrl(query: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);
  const trimmed = query.trim();

  if (trimmed) {
    url.searchParams.set(INDUSTRY_NEWS_SEARCH_PARAM, trimmed);
  } else {
    url.searchParams.delete(INDUSTRY_NEWS_SEARCH_PARAM);
  }

  window.history.replaceState({}, '', url.toString());
}

export function useIndustryNewsSearch() {
  const [searchQuery, setSearchQueryState] = useState(readSearchFromUrl);

  useEffect(() => {
    const syncFromUrl = () => setSearchQueryState(readSearchFromUrl());
    window.addEventListener('popstate', syncFromUrl);
    return () => window.removeEventListener('popstate', syncFromUrl);
  }, []);

  const setSearchQuery = useCallback((value: string) => {
    setSearchQueryState(value);
    writeSearchToUrl(value);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchQuery('');
  }, [setSearchQuery]);

  return {
    searchQuery,
    setSearchQuery,
    clearSearch,
    hasSearch: searchQuery.trim().length > 0,
  };
}
